import { h } from "preact";

import { renderHtml } from "../helpers.js";
import i18n from "../i18n.js";

import Avatar from "./Avatar.jsx";
import Button from "./Button.jsx";
import Tag from "./Tag.jsx";

export default function TaskModuleIntro({ onStart, task, user }) {
  return (
    <div class="row">
      <div class="col s12 l8 offset-l2">
        <div class="mb-32">
          <Avatar user={user} noHover small plain class="mr-8" />
          <Tag noHover class="mb-0">
            {task.objective}
          </Tag>
        </div>
        <h4 class="task-modal-intro__title" data-qa="task-title">
          {i18n.t(`tasks.${task.id}.title`)}
        </h4>
        <p class="t-body2 mt-0 mb-64 color-shades-charcoal">
          {renderHtml(i18n.t(`tasks.${task.id}.description`))}
        </p>

        <Button onClick={onStart} class="btn btn-primary">
          {i18n.t("actions.start")}
        </Button>
      </div>
    </div>
  );
}
